import { render } from "./RuleDialog.vue?vue&type=template&id=3d0086ea"
import script from "./RuleDialog.vue?vue&type=script&lang=js"
export * from "./RuleDialog.vue?vue&type=script&lang=js"

import "./RuleDialog.vue?vue&type=style&index=0&id=3d0086ea&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__